import { createFileRoute, redirect } from '@tanstack/react-router'
import logo from '@/assets/images/logo.png'
import { LoginForm } from '@/features/auth'
import { FeaturesShowcase } from '@/shared/components/features/FeaturesShowcase'
export const Route = createFileRoute('/login')({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: LoginPage,
})

function LoginPage() {
  const handleLoginSuccess = () => {
    // Hard navigation to reset all in-memory state (Zustand, React Query, router context)
    window.location.href = '/dashboard'
  }

  return (
    <div className='grid min-h-svh lg:grid-cols-2'>
      <div className='flex flex-col gap-4 p-6 md:p-10'>
        <div className='flex justify-center gap-2 md:justify-start'>
          <a
            href='/'
            className='flex items-center gap-2 md:gap-3 font-bold text-xl sm:text-2xl md:text-3xl lg:text-2xl xl:text-3xl text-slate-800 dark:text-slate-200'
          >
            <div className='flex size-16 sm:size-18 md:size-20 lg:size-18 xl:size-20 items-center justify-center rounded-md'>
              <img
                src={logo}
                alt='logo'
                className='w-full h-full object-contain'
              />
            </div>
            Coobird
          </a>
        </div>
        <div className='flex flex-1 items-center justify-center'>
          <div className='w-full max-w-lg'>
            <LoginForm onSuccess={handleLoginSuccess} />
          </div>
        </div>
      </div>
      <div className='relative hidden lg:block'>
        {/* Light theme background */}

        <div className='absolute h-full w-full bg-white dark:hidden'>
          <div className='absolute bottom-0 left-0 right-0 top-0 bg-[linear-gradient(to_right,#4f4f4f2e_1px,transparent_1px),linear-gradient(to_bottom,#4f4f4f2e_1px,transparent_1px)] bg-[size:14px_24px] [mask-image:linear-gradient(to_bottom,transparent_0%,#000_15%,#000_85%,transparent_100%)]'>
            <FeaturesShowcase />
          </div>
        </div>

        {/* Dark theme background */}
        <div className='absolute h-full w-full bg-slate-950 hidden dark:block'>
          <div className='absolute bottom-0 left-0 right-0 top-0 bg-[linear-gradient(to_right,#4f4f4f2e_1px,transparent_1px),linear-gradient(to_bottom,#4f4f4f2e_1px,transparent_1px)] bg-[size:14px_24px] [mask-image:linear-gradient(to_bottom,transparent_0%,#000_15%,#000_85%,transparent_100%)]'>
            <FeaturesShowcase />
          </div>
        </div>
      </div>
    </div>
  )
}
